import { StoreProvider } from 'easy-peasy';
import { Provider } from 'jotai';
// Lazy load Jotai DevTools
import { DevTools } from 'jotai-devtools';
import css from 'jotai-devtools/styles.css?inline';
import { createRoot } from 'react-dom/client';
import App from './App';
import { processSSRData } from './model/ssr-data/ssr-data';
import store from './store';
import { jotaiStore } from './store/store';

const JotaiDevTools = () =>
    import.meta.env.DEV ? (
        <>
            <style>{css}</style>
            <DevTools />
        </>
    ) : null;

// import { scan } from 'react-scan';
// scan({
//     enabled: true,
// });

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

// Pre-populate state from SSR before first render/hydration
try {
    processSSRData();
} catch (err) {
    console.warn('[SSR] Failed to pre-process SSR data before hydration', err);
}

const appTree = (
    <Provider store={jotaiStore}>
        <JotaiDevTools />
        <StoreProvider store={store}>
            <App />
        </StoreProvider>
    </Provider>
);

// if (container.hasChildNodes()) {
// Hydrate server-rendered markup (PostTab only)
// hydrateRoot(container, appTree);
// } else {
createRoot(container).render(appTree);
// }
